/*
represents open-ended JSON object for Interaction settings
for MVP the cs1 cachefile is the only setting, but there will be more down the road
*/

import { ImmutableClass, types } from "../../helpers/Util";

class InteractionSettings extends ImmutableClass {
  type: string; // type is requred
  cacheFile?: string;
  intervalSetID?: number;
  instanceFields?: any;


  static readonly serializableFields = new Map([
    ["type", [types.string]],
    ["cacheFile", [types.undefined, types.string]],
    ["intervalSetID", [types.undefined, types.number]],
    ["instanceFields", [types.undefined, types.object]],
  ]);

  constructor(type = "blueprint", cacheFile?: string, intervalSetID?: number, instanceFields?:any) {
    super();
    this.type = type;
    this.cacheFile = cacheFile;
    this.intervalSetID = intervalSetID;
    this.instanceFields = instanceFields;

  }
}

export default InteractionSettings;
